import React, { Component } from 'react';
import './navbar.css';
import './subHeaderDrivers.css';
import NavbarDrivers from './NavbarDrivers';
import NavbarGeneral from './NavbarGeneral';
import NavbarParking from './NavbarParking';
import MobileAppBanner from './MobileAppBanner';
import AgnosticBanner from './AgnosticBanner';

import SideBar from '../SideBar';
import logo from '../../images/whiteLogo.png';
import phone from '../../images/phone.svg';
import { getURLCity } from '../../utils';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      ariaExpanded: false
    };
  }

  // componentDidUpdate(prevProps) {
  //   if (this.props !== prevProps) {
  //     console.log(this.props, prevProps);
  //     this.props.loadData();
  //     this.props.retrieveProfile();
  //     console.log('here');
  //   }
  // }

  toggle = () => {
    this.setState({
      isActive: !this.state.isActive,
      ariaExpanded: !this.state.ariaExpanded
    });
  };

  closeDrawer = () => {
    this.setState({ ariaExpanded: false, isActive: false });
  };

  links = () => {
    const {
      email,
      token,
      logout,
      logoutParking,
      history,
      profile_image,
      first_name,
      last_name,
      loggedIn,
      status,
      operating_city
    } = this.props;
    if (history.location.pathname === '/impark') {
      // switch back to logged in when login is set up
      return (
        <NavbarParking
          logoutParking={logoutParking}
          history={history}
          closeDrawer={this.closeDrawer}
        />
      );
    } else if (email && token) {
      return (
        <NavbarDrivers
          className="changeable"
          logout={logout}
          loggedIn={loggedIn}
          history={history}
          email={email}
          profileImage={profile_image}
          firstName={first_name}
          lastName={last_name}
          status={status}
          operatingCity={operating_city}
          closeDrawer={this.closeDrawer}
        />
      );
    } else {
      return (
        <NavbarGeneral
          className="changeable"
          closeDrawer={this.closeDrawer}
          {...this.props}
        />
      );
    }
  };

  render() {
    const {
      email,
      token,
      status,
      firstName,
      profileImage,
      showMobileAppBanner,
      closeAppBanner,
      detectedOs,
      agnostic,
      closeAgnosticBanner
    } = this.props;

    // window.onscroll = () => {
    //   this.scrollNav();
    // };

    // const subheader = () => {
    //   if (email && token) {
    //     return <SubHeaderDrivers status={status} history={history} />;
    //   }
    // };

    return (
      <div>
        {showMobileAppBanner ? (
          <MobileAppBanner os={detectedOs} closeBanner={closeAppBanner} />
        ) : null}
        {agnostic ? (
          <AgnosticBanner closeBanner={closeAgnosticBanner} />
        ) : null}
        <nav
          className={`navbar navbar--full-width navbar-default ${
            showMobileAppBanner
              ? 'navbar-fixed-with-banner'
              : 'navbar-fixed-top'
          }`}>
          <SideBar
            status={status}
            profileImage={profileImage}
            firstName={firstName}
            signedIn={token && email}
            showMobileAppBanner={showMobileAppBanner}
            showAgnosticBanner={agnostic}
          />
          <div
            id="container-scrolled"
            className="scrolled container navbar--no-padding">
            <div
              className={`navbar-header${
                email && token ? '' : ' logged-out'
              }`}>
              <a className="navbar-brand" href="/">
                <img
                  className="navbar-white-logo"
                  src={logo}
                  alt="Autzu Logo"
                />
              </a>

              <a className="phone-icon" href={`/${getURLCity()}/contact/call`}>
                <img src={phone} alt="Phone Icon" />
              </a>
            </div>
            <div
              aria-expanded={this.state.ariaExpanded}
              className={`collapse navbar__mobile-links navbar-collapse ${
                this.state.ariaExpanded ? 'in' : ''
              }`}
              id="main-nav-collapse">
              {this.links()}
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/Navbar.js